import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import useHeaderActions from 'modules/attendance/components/ClockIn/CardRightAction/useHeaderActions'
import {
  ResponsivePage,
  ResponsivePageActionsInterface,
} from 'modules/layout/components/ResponsivePage'

import TimesheetButtons from './TimesheetButtons'
import { TimesheetTabsLayout } from './TimesheetTabsLayout'

interface Props {
  employeeId: string
  showHourBalance: boolean
  isDaily: boolean
}

const WeeklyViewBody = ({
  employeeId,
  children,
  showHourBalance,
  isDaily,
}: React.PropsWithChildren<Props>) => {
  const { headerOptions } = useHeaderActions()

  const responsiveActionButtons: ResponsivePageActionsInterface = {
    secondary: headerOptions.map((item) => {
      return {
        title: item.title ?? '',
        description: item.description ?? '',
        onClick: () => (item.onClick ? item.onClick() : undefined),
      }
    }),
  }

  return (
    <ResponsivePage.Body variant="full" actions={responsiveActionButtons} showHeader={false}>
      <TimesheetTabsLayout>
        {isDaily ? (
          <></>
        ) : (
          <TimesheetButtons
            employeeId={employeeId}
            showHourBalance={showHourBalance}
            isDaily={isDaily}
          />
        )}
        <Box width="full">{children}</Box>
      </TimesheetTabsLayout>
    </ResponsivePage.Body>
  )
}
export default WeeklyViewBody
